<template>
  <a class="p-0" :href="'tel:' + number.replace(/\s/g, '')">
    <!--    <font-awesome-icon v-if="showIcon" icon="fa-phone" />-->
    <i v-if="showIcon" class="fas fa-phone mr-2"></i>
    {{ number }}
  </a>
</template>
<script>
export default {
  name: 'phone-number',
  props: {
    number: String,
    showIcon: Boolean
  },
  methods: {
    trim: function (string) {
      return string.trim();
    }
  }
}
</script>